<template>
    <div class="bottom-menu">
        <div class="item" :class="current == 'panchanga' ? 'text-prime-400' : ''">
            <router-link :to="{ name: 'panchanga' }">
                <IconGraph height="24"  />
                <div class="title">{{ $t('panchanga') }}</div>
            </router-link>
        </div>
        <div class="item" :class="current == 'calendar' ? 'text-prime-400' : ''">
            <router-link :to="{ name: 'calendar' }">
                <IconCalendar height="24"  />
                <div class="title">{{ $t('calendar') }}</div>
            </router-link>
        </div>
        <div class="item" :class="current == 'dayprediction' ? 'text-prime-400' : ''">
            <router-link :to="{ name: 'dayprediction' }">
                <IconNews height="36" />
                <div class="title">{{ $t('prediction') }}</div>
            </router-link>
        </div>
        <div class="item" :class="current == 'support' ? 'text-prime-400' : ''">
            <router-link :to="{ name: 'support' }">
                <SupportSign class="w-6 h-6" />
                <div class="title">{{ $t('support') }}</div>
            </router-link>
        </div>
        <div class="item" :class="current == 'profile' || current == 'settings' ? 'text-prime-400' : ''">
            <router-link :to="{ name: loggedIn ? 'profile' : 'settings' }">
                <SettingsSign size="6" />
                <div class="title">{{ $t('settings') }}</div>
            </router-link>
        </div>
    </div>
</template>

<script>
import SettingsSign from '@/components/visual/SettingsSign'
import SupportSign from '@/components/visual/SupportSign'
import IconNews from '@/components/visual/icons/IconNews'
import IconGraph from '@/components/visual/icons/IconGraph'
import IconCalendar from '@/components/visual/icons/IconCalendar'
import { mapGetters } from 'vuex'
export default {
    components: { SettingsSign, SupportSign, IconNews, IconCalendar, IconGraph },
    computed: {
        current() {
            return this.$route.name
        },
        ...mapGetters('auth', {
            loggedIn: 'loggedIn',
        }),
    }
}
</script>

<i18n locale="ru" lang="yaml">
    prediction: "Прогноз"
    panchanga: "Панчанга"
    calendar: "Календарь"
    support: "Поддержка"
    settings: "Настройки"
</i18n>

<i18n locale="en" lang="yaml">
    prediction: "Prediction"
    panchanga: "Panchanga"
    calendar: "Calendar"
    support: "Support"
    settings: "Settings"
